// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"slick_sliderWrapper__fb0ke"};